import { render } from "./CurriculumEditTableRowSection.vue?vue&type=template&id=3b94b1d8&scoped=true&ts=true"
import script from "./CurriculumEditTableRowSection.vue?vue&type=script&lang=ts"
export * from "./CurriculumEditTableRowSection.vue?vue&type=script&lang=ts"

import "./CurriculumEditTableRowSection.vue?vue&type=style&index=0&id=3b94b1d8&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b94b1d8"]])

export default __exports__